import type { ReactNode } from 'react';

/**
 * One region of an organization's page, shown or hidden by the address. A shown region lays its panels out
 * as the page's own blocks (`display: contents`), so two of them keep the page's gap between them, as
 * panels do on every other page. A hidden region keeps only `hidden`: a display class would win over it.
 */
export function Region({ shown, children }: { shown: boolean; children?: ReactNode }) {
	return (
		<div hidden={!shown} className={shown ? 'contents' : undefined}>
			{children}
		</div>
	);
}
